import { Types } from "../actions/AMActions";

const initialState = {
    areaList: {},
    isAMUpdated: 0,
    actionResult: {},
    amOrderById: {},
    amOrderFiles: [],
    amAddFiles: [],
    maintenanceType: {},
    amCreateOrder: {},
    checkItemGroupListById: {},
    checkItemsForTask: {},
    amOrderList: {},
    amOrderDelete: {},
};

export const amReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_AREAS:
            return {
                ...state,
                areaList: action.payload || state.areaList,
            };
        case Types.SET_MAINTENANCE_TYPE:
            return {
                ...state,
                maintenanceType: action.payload || state.maintenanceType,
            };
        case Types.AM_UPDATE_SUCCESS:
            return {
                ...state,
                actionResult: action.payload || state.actionResult,
                isAMUpdated: 1,
            };
        case Types.SET_AM_ORDER_DETAIL_BY_ID:
            return {
                ...state,
                amOrderById: action.payload.data || state.amOrderById,
                showDates: action.payload?.showDates,
            };
        case Types.AM_UPDATE_ORDER_SUCCESS:
            return {
                ...state,
                amUpdateOrder: action.payload || state.amUpdateOrder,
            };
        case Types.AM_UPDATE_ORDER_SUCCESS_AFTER:
            return {
                ...state,
                amUpdateOrder: {},
            };
        case Types.AM_CREATE_ORDER_SUCCESS:
            return {
                ...state,
                amCreateOrder: action.payload || state.amCreateOrder,
                isAMCreated: 1,
            };
        case Types.AM_CREATE_ORDER_SUCCESS_AFTER:
            return {
                ...state,
                amCreateOrder: {},
                isAMCreated: 0,
            };
        case Types.SET_AM_ORDER_FILES:
            return {
                ...state,
                amOrderFiles: action.payload || state.amOrderFiles,
            };
        case Types.POST_AM_ADD_FILES_SUCCESS:
            return {
                ...state,
                amAddFiles: action.payload || state.amAddFiles,
            };
        case Types.SET_AM_ORDER_LIST:
            return {
                ...state,
                amOrderList: action.payload || state.amOrderList,
            };
        case Types.DELETE_AM_ORDER_SUCCESS:
            return {
                ...state,
                isAMOrderDeleted: 1,
                amOrderDelete: action.payload || state.amOrderDelete,
            };

        case Types.AM_DELETE_ORDER_SUCCESS_AFTER:
            return {
                ...state,
                amOrderDelete: {},
                isAMCreated: 0,
            };
        case Types.SHOW_SNACK_MESSAGE:
            return {
                ...state,
                error: action.payload,
            };
        case Types.SET_CHECKITEMGROUPS_BY_ORDERID:
            return {
                ...state,
                checkItemGroupListById: action.payload || state.checkItemGroupListById,
            };
        case Types.SET_CHECKITEMS_FOR_TASK:
            return {
                ...state,
                checkItemsForTask: action.payload || state.checkItemsForTask,
            };
        case Types.RESET_AM_ORDER_LIST:
            return {
                ...state,
                amOrderList: {},
            };
        case Types.RESET_AM_ORDER_DETAIL_BY_ID:
            return {
                ...state,
                amOrderById: {},
            };
        case Types.RESET_DELETE_ORDER_AM:
            return {
                ...state,
                amOrderDelete: {},
            };
        default:
            return state;
    }
};
